import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import RegisterUser from './RegisterUser';
import StepsWrapper from './questionair/StepsWrapper';
import HomeForSuperAdmin from './HomeForSuperAdmin';
import HomeForUser from './HomeForUser';
import HomeForCompanyAdmin from './HomeForCompanyAdmin'; 

const Home = () => {
  const [role, setRole] = useState(null); // State to store user role
  const [isFormFinished, setIsFormFinished] = useState(null); // null = checking, true/false = checked
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user role from localStorage or an API
    const userRole = localStorage.getItem('role'); // Assuming role is saved in localStorage
    setRole(userRole);

    // Check if company admin has finished registration
    if (userRole === 'companyAdmin') {
      checkCompanyRegistration();
    } else {
      setIsFormFinished(true); // Not a company admin, so no check needed
    }
  }, []);

  const checkCompanyRegistration = async () => {
    try {
      const response = await axios.post('/is-form-finished');
      if (response.data.status) {
        setIsFormFinished(response.data.isFormFinished);
        // If company not registered, redirect to register-company
        if (!response.data.isFormFinished) {
          navigate('/register-company');
        }
      } else {
        setIsFormFinished(false);
        navigate('/register-company');
      }
    } catch (error) {
      console.error('Error checking company registration:', error);
      setIsFormFinished(false);
      navigate('/register-company');
    }
  };

  // Show loading while checking registration status
  if (role === 'companyAdmin' && isFormFinished === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {role === 'superAdmin' ? (
        <HomeForSuperAdmin />
      ) : role === 'companyAdmin' ? (
        isFormFinished ? <HomeForCompanyAdmin /> : null
      ):(
        <HomeForUser />
      )}
    </div>
  );
};

export default Home;
